import styled from 'styled-components';

export const Content = styled.div`
  float: left;
  width: 100%;
  padding: 2rem;
  background: ${({ theme }) => theme.colors.LIGHT1};

  @media (max-width: 1024px) {
    padding: 20px 10px;
  }
`;

export const Count = styled.div`
  float: left;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: row;
  text-align: center;
  color: ${({ theme }) => theme.colors.TEXT1};
  font-weight: 700;
  text-decoration: underline;
  align-items: center;
  font-size: 20px;

  button {
    background: none;
    cursor: pointer;
    margin-right: 5px;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }
  @media (max-width: 1024px) {
    font-size: 10px;
  }
`;

export const Summary = styled.div`
  float: left;
  width: 100%;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 1rem 0;
  border-bottom: ${({ theme }) => `2px solid ${theme.colors.BORDER}`};
  border-top: ${({ theme }) => `2px solid ${theme.colors.BORDER}`};

  div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    span {
      border-right: ${({ theme }) => `2px solid ${theme.colors.BORDER}`};
      padding: 0.5rem 1rem;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT1};
      width: 50%;
      text-align: right;
      font-weight: 700;
    }

    strong {
      text-align: left;
      padding: 0.5rem 1rem;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT1};
      font-weight: 700;
    }
  }

  @media (max-width: 1024px) {

    div {
      span {
        font-size: 10px;
      }
      strong {
        font-size: 10px;
      }
    }
  }
`;

export const Options = styled.div`
  float: left;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: row;

  button {
    display: flex;
    padding: 8px 15px 8px 15px;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 8px;
    margin-right: 5px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      background: #333 !important;
    }

    &.excel {
      background: #179d46;
    }

    &.pdf {
      background: #df4c2a;
    }

    &.sync {
      background: #4080e0ff;
    }

    div {
      display: flex;
      flex-direction: column;
      padding: 0 0 0 5px;

      h3 {
        font-size: 8px;
        text-align: left;
        font-weight: normal;
        color: ${({ theme }) => theme.colors.TEXT2};
        margin: 0px;
      }

      h2 {
        font-size: 10px;
        text-align: left;
        color: ${({ theme }) => theme.colors.TEXT2};
        margin: 0px;
        font-weight: 700;
      }
    }
  }

  @media (max-width: 1024px) {

    flex-direction: column;

    button {
      align-items: center;
      justify-content: flex-start;
      margin: 0 0 5px 0;

      &:last-child {
        margin: 0px;
      }
    }
  }
`;
